import script from "./Dashboard.vue?vue&type=script&lang=ts&setup=true"
export * from "./Dashboard.vue?vue&type=script&lang=ts&setup=true"

import "./Dashboard.vue?vue&type=style&index=0&id=0893244c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0893244c"]])

export default __exports__